// For IE11 support
import { enableES5 } from 'immer';
enableES5();

import produce from 'immer';
import { TICKET_MGMT_TYPES } from '../../constants/actionTypes/ticketMgmtActionTypes';

export const INITIAL_STATE = {
    loaded: false,
    activeCategory: '',
    entities: []
};

export default produce((draft = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case TICKET_MGMT_TYPES.GET_CATEGORIES:
            draft.loaded = true;
            draft.entities = action.data;
            break;

        case TICKET_MGMT_TYPES.SELECT_CATEGORY:
            draft.activeCategory = action.activeCategory;
            break;

        case TICKET_MGMT_TYPES.RENAME_CATEGORY: {
            const { oldCategory, category , categoryEs } = action;
            draft.activeCategory = { 'ticketCategory': category, 'ticketCategorySpanishName':categoryEs };
            draft.entities = Object.fromEntries(
                Object.entries(draft.entities)
                    .map(([entity, value]) => {
                        if(entity === oldCategory){
                            return  [category, categoryEs];
                        }
                        return  [entity, value];
                    }),
            );
            break;
        }

        default:
            return draft;
    }
});